import gtm from '../../../utils/gtm';
import { init, off } from "../../../services/analytics/gtm";

export const initGTM = (payload) => { payload?.id && init(payload?.id, payload.gtmEnv, payload.gtmAuth); };
export const destroyGTM = (payload) => { payload?.id && off(payload?.id); };

export const appIdSetToGtm = (payload) => gtm.push({ event: 'journey-appid-set', ...payload })
export const stepCompleteToGtm = (payload) => gtm.push({ event: 'step-complete', ...payload });
export const submissionToGtm = (payload) => gtm.push({ event: 'submission', ...payload });
